<div class="otp-fondo" [class.otp-fondo--modal]="modo === 'modal'">
  <div class="otp-card" role="dialog" aria-labelledby="otp-titulo" [attr.aria-modal]="modo === 'modal'">

    <ng-container [ngSwitch]="estado">

      <ng-container *ngSwitchCase="'cargando'">
        <div class="otp-cargando" aria-live="polite">
          <span class="otp-spinner" aria-hidden="true"></span>
          <span>Verificando el enlace...</span>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="'otp'">
        <h2 id="otp-titulo">{{ modo === 'modal' ? 'La sesión venció' : 'Verificación de seguridad' }}</h2>
        <p *ngIf="modo === 'modal'">Para guardar el formulario, verifique su identidad de nuevo. Lo que diligenció se conserva.</p>
        <p *ngIf="destinatarios.length; else sinDestinatarios">
          Enviamos un código de verificación a
          <ng-container *ngFor="let correo of destinatarios; let ultimo = last">
            <strong>{{ correo }}</strong><span *ngIf="!ultimo">, </span>
          </ng-container>.
        </p>
        <ng-template #sinDestinatarios>
          <p>Enviamos un código de verificación a su correo electrónico.</p>
        </ng-template>

        <form class="otp-formulario" (ngSubmit)="validarOtp()">
          <label class="otp-etiqueta" for="otp-codigo">Código de verificación</label>
          <input
            id="otp-codigo"
            name="otp"
            type="text"
            class="otp-input"
            [(ngModel)]="otp"
            (keydown.enter)="$event.preventDefault(); validarOtp()"
            maxlength="8"
            autocomplete="one-time-code"
            autocapitalize="characters"
            spellcheck="false"
            [disabled]="validando"
            [attr.aria-invalid]="!!mensajeError"
            aria-describedby="otp-error"
            autofocus
          />
          <p id="otp-error" class="otp-error" role="alert" *ngIf="mensajeError">{{ mensajeError }}</p>

          <button type="submit" class="ms-Button ms-Button--primary otp-boton" [disabled]="validando">
            <span class="ms-Button-label">{{ validando ? 'Validando...' : 'Validar código' }}</span>
          </button>
        </form>

        <div class="otp-acciones">
          <button type="button" class="otp-enlace" (click)="enviarOtp()" [disabled]="enviando || segundosParaReenvio > 0">
            <ng-container *ngIf="enviando">Enviando código...</ng-container>
            <ng-container *ngIf="!enviando && segundosParaReenvio > 0">Reenviar código en {{ segundosParaReenvio }} s</ng-container>
            <ng-container *ngIf="!enviando && segundosParaReenvio === 0">Reenviar código</ng-container>
          </button>
          <button type="button" class="otp-enlace otp-enlace--secundario" *ngIf="modo === 'modal'" (click)="cancelar()">Cancelar</button>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="'bloqueado'">
        <h2 id="otp-titulo">Verificación bloqueada</h2>
        <p>
          Se superó el número de intentos permitidos.
          <ng-container *ngIf="bloqueadoHasta">Podrá solicitar un código nuevo a partir de las <strong>{{ bloqueadoHasta | date:'h:mm a' }}</strong>.</ng-container>
        </p>
        <div class="otp-acciones">
          <button type="button" class="ms-Button ms-Button--primary otp-boton" (click)="reintentar()">
            <span class="ms-Button-label">Reintentar</span>
          </button>
          <button type="button" class="otp-enlace otp-enlace--secundario" *ngIf="modo === 'modal'" (click)="cancelar()">Cancelar</button>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="'cerrado'">
        <h2 id="otp-titulo">{{ cierre.titulo }}</h2>
        <p>{{ cierre.detalle }}</p>
        <div class="otp-acciones" *ngIf="modo === 'modal'">
          <button type="button" class="otp-enlace otp-enlace--secundario" (click)="cancelar()">Cerrar</button>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="'error'">
        <h2 id="otp-titulo">No fue posible verificar el enlace</h2>
        <p class="otp-error" role="alert">{{ mensajeError }}</p>
        <div class="otp-acciones">
          <button type="button" class="ms-Button ms-Button--primary otp-boton" (click)="reintentar()">
            <span class="ms-Button-label">Reintentar</span>
          </button>
          <button type="button" class="otp-enlace otp-enlace--secundario" *ngIf="modo === 'modal'" (click)="cancelar()">Cancelar</button>
        </div>
      </ng-container>

    </ng-container>
  </div>
</div>
